import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { TagPushCarousel } from 'analytics/carousel'

import { podProduct, tudoProduct } from 'constants/cards'
import { withMobile } from 'utils/mobile'

import {
    homeProductAliRefModalSelector,
    homeProductModalSelector,
    homeProductOthersModalSelector,
    homePatModalSelector
} from 'store/selectors/home'

import {
    closeProductAliRefModal,
    closeProductModal,
    closeProductOthersModal,
    closePatModal
} from 'store/actions/home'

import PatTooltipModal from 'components/SwitchButton/tooltip/PatTooltipModal'

import { ProductAliRefModal, ProductModal, ProductOthersModal } from './modals'

import ProductForm from './ProductForm'
import ProductContainerMobile from './ProductContainerMobile'
import ProductFormLayout from './ProductFormLayout'

import {
    Container,
    Content,
    DivImage,
    Info,
    Title,
    Subtitle,
    Text,
    Link,
    ModalWrap
} from './ProductContainer.style'
import useProductImage from 'hooks/useProductImage'

const ProductContainer = ({ data, type, mobile, ...otherProps }) => {
    const info = {
        TUDO: tudoProduct,
        POD: podProduct
    }

    const product = { ...data, ...info[type] }

    const image = useProductImage(product)

    useEffect(() => {
        TagPushCarousel.viewItem([product])
    }, [])

    const {
        patModal,
        productModal,
        othersModal,
        aliRefModal,
        closePatModal,
        closeProductAliRefModal,
        closeProductModal,
        closeProductOthersModal
    } = otherProps

    if (mobile) {
        return (
            <>
                <ProductContainerMobile product={product} />
                <ModalWrap>
                    {productModal && (
                        <ProductModal
                            product={product}
                            group={productModal}
                            onClose={closeProductModal}
                        />
                    )}
                    {othersModal && (
                        <ProductOthersModal
                            product={product}
                            onClose={closeProductOthersModal}
                        />
                    )}
                    {aliRefModal && (
                        <ProductAliRefModal onClose={closeProductAliRefModal} />
                    )}
                    {patModal && <PatTooltipModal onClose={closePatModal} />}
                </ModalWrap>
            </>
        )
    }

    return (
        <Container>
            <Content>
                <DivImage $gradientColor={product.gradientColor}>
                    <img
                        id={product.id}
                        src={image}
                        alt={`Produto ${product.name}`}
                    />
                </DivImage>
                <Info>
                    <Title $color={product.color}>{product.title}</Title>
                    <Subtitle $color={product.color}>
                        {product.subtitle}
                    </Subtitle>
                    <Text>{product.text}</Text>
                    <Link href={product.link}>Saiba mais</Link>
                </Info>
            </Content>
            <ProductForm product={product}>
                <ProductFormLayout />
            </ProductForm>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    patModal: homePatModalSelector(state),
    productModal: homeProductModalSelector(state),
    othersModal: homeProductOthersModalSelector(state),
    aliRefModal: homeProductAliRefModalSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    closePatModal: () => dispatch(closePatModal()),
    closeProductModal: () => dispatch(closeProductModal()),
    closeProductAliRefModal: () => dispatch(closeProductAliRefModal()),
    closeProductOthersModal: () => dispatch(closeProductOthersModal())
})

export default withMobile(
    connect(mapStateToProps, mapDispatchToProps)(ProductContainer)
)
